const CheckIcon = require("../../styles/images/greenCheck.svg");
const CancelIcon = require("../../styles/images/redCancel.svg");

interface Permission {
  label: string;
  value: boolean;
}

interface ParticipantObject {
  name: string;
  className?: string;
  permissions?: Permission[];
  redacted?: boolean;
  permissionExpiryStatus?: {
    status: string;
  };
}

export const generateTooltipHTML = (participant: ParticipantObject): string => {
  if (participant.redacted) {
    return `
      <div class="participant-popup-content" id="participant-tooltip">
        <div class="popup-participant-name">${participant.name}</div>
        <div class="popup-participant-class">${participant.className || ""}</div>
        <div class="redacted-banner">REDACTED</div>
      </div>
    `;
  }

  const permissionsHTML =
    participant.permissions
      ?.map(
        permission => `
      <div class="permission-item">
        <div class="permission-icon-circle">
          <img src="${permission.value ? CheckIcon : CancelIcon}" alt="${
          permission.value ? "check" : "cancel"
        }" />
        </div>
        <span class="permission-text">${permission.label}</span>
      </div>
    `
      )
      .join("") || "";

  return `
    <div class="participant-popup-content" id="participant-tooltip">
      <div class="popup-participant-name">${participant.name}</div>
      <div class="popup-participant-class">${participant.className || ""}</div>
      ${participant.permissionExpiryStatus?.status ? `<div class="current-badge">${participant.permissionExpiryStatus.status}</div>` : ""}
      <div class="participant-permissions-list">
        ${permissionsHTML}
      </div>
    </div>
  `;
};

const isElementMostlyVisible = (element: HTMLElement): boolean => {
  const container = element.closest(".geo-parti");
  if (!container) return true;

  const elementRect = element.getBoundingClientRect();
  const containerRect = container.getBoundingClientRect();

  const elementTop = elementRect.top;
  const elementBottom = elementRect.bottom;
  const containerTop = containerRect.top;
  const containerBottom = containerRect.bottom;

  const visibleTop = Math.max(elementTop, containerTop);
  const visibleBottom = Math.min(elementBottom, containerBottom);
  const visibleHeight = Math.max(0, visibleBottom - visibleTop);

  const elementHeight = elementRect.height;
  const visiblePercentage = (visibleHeight / elementHeight) * 100;

  return visiblePercentage >= 90;
};

export const initializeParticipantTooltips = (): (() => void) => {
  //@ts-ignore
  $(".participant-tooltip-wrapper").remove();

  //@ts-ignore
  $('[data-toggle="tooltip"][data-participant-tooltip]').tooltip({
    html: true,
    container: "body",
    placement: "top",
    template:
      '<div class="tooltip participant-tooltip-wrapper" role="tooltip"><div class="tooltip-arrow participant-popup-arrow"></div><div class="tooltip-inner participant-permissions-popup"></div></div>',
    trigger: "manual"
  });

  //@ts-ignore
  $('[data-toggle="tooltip"][data-participant-tooltip]')
    .on("mouseenter", function () {
      const element = this as HTMLElement;
      if (isElementMostlyVisible(element)) {
        //@ts-ignore
        $(this).tooltip("show");
      }
    })
    .on("mouseleave", function () {
      //@ts-ignore
      $(this).tooltip("hide");
    });

  return () => {
    //@ts-ignore
    $('[data-toggle="tooltip"][data-participant-tooltip]').off(
      "mouseenter mouseleave"
    );
    //@ts-ignore
    $(".participant-tooltip-wrapper").remove();
  };
};
